import * as TYPES from '../../store/types';

const state = {
  contracts: {},
  markedItems: [],
  // cart: [],
};

// const findArticle = (day, articleno) => {
//   let menu = []
//
//   if( day == 'Monday') {
//     menu = Array.isArray(state.contracts.menuMonday.Article) ? state.contracts.menuMonday.Article : [state.contracts.menuMonday.Article]
//   }
//   if( day == 'Tuesday')
//     menu = Array.isArray(state.contracts.menuTuesday.Article) ? state.contracts.menuTuesday.Article : [state.contracts.menuTuesday.Article]
//   if( day == 'Wednesday')
//     menu = Array.isArray(state.contracts.menuWednesday.Article) ? state.contracts.menuWednesday.Article : [state.contracts.menuWednesday.Article]
//   if( day == 'Thursday')
//     menu = Array.isArray(state.contracts.menuThursday.Article) ? state.contracts.menuThursday.Article : [state.contracts.menuThursday.Article]
//   if( day == 'Friday')
//     menu = Array.isArray(state.contracts.menuFriday.Article) ? state.contracts.menuFriday.Article : [state.contracts.menuFriday.Article]
//
//   let foundArticle = menu.find(article => article.Article == articleno)
//   return foundArticle
// }

const findArticleLineNo = (day, lineno) => {
  let menu = [];

  if (day === 'Monday') {
    menu = Array.isArray(state.contracts.menuMonday.Article)
      ? state.contracts.menuMonday.Article
      : [state.contracts.menuMonday.Article];
  }
  if (day === 'Tuesday') {
    menu = Array.isArray(state.contracts.menuTuesday.Article)
      ? state.contracts.menuTuesday.Article
      : [state.contracts.menuTuesday.Article];
  }
  if (day === 'Wednesday') {
    menu = Array.isArray(state.contracts.menuWednesday.Article)
      ? state.contracts.menuWednesday.Article
      : [state.contracts.menuWednesday.Article];
  }
  if (day === 'Thursday') {
    menu = Array.isArray(state.contracts.menuThursday.Article)
      ? state.contracts.menuThursday.Article
      : [state.contracts.menuThursday.Article];
  }
  if (day === 'Friday') {
    menu = Array.isArray(state.contracts.menuFriday.Article)
      ? state.contracts.menuFriday.Article
      : [state.contracts.menuFriday.Article];
  }

  const foundArticle = menu.find(article => article.LineNo == lineno);
  return foundArticle;
};

/* eslint-disable no-param-reassign */
const mutations = {
  [TYPES.CONTRACTS_SET](st, obj) {
    st.contracts = obj;
  },
  [TYPES.CONTRACT_ACTIVE](st, id) {
    st.contract = id;
  },
  [TYPES.SET_ARTICLE_INTERVAL](st, obj) {
    obj.art.Interval = obj.interval;
    obj.art.Dato = obj.date;
  },
  [TYPES.SET_ARTICLE_QUANTITY](st, obj) {
    obj.article.Quantity = obj.qty;
  },
  [TYPES.MENU_REMOVE_ARTICLE](st, obj) {
    let index = '';

    switch (obj.day) {
      case 'Monday':
        if (Array.isArray(st.contracts.menuMonday.Article)) {
          index = st.contracts.menuMonday.Article.indexOf(obj.article);
          st.contracts.menuMonday.Article.splice(index, 1);
        } else {
          st.contracts.menuMonday.Article = [];
        }
        break;
      case 'Tuesday':
        if (Array.isArray(st.contracts.menuTuesday.Article)) {
          index = st.contracts.menuTuesday.Article.indexOf(obj.article);
          st.contracts.menuTuesday.Article.splice(index, 1);
        } else {
          st.contracts.menuTuesday.Article = [];
        }
        break;
      case 'Wednesday':
        if (Array.isArray(st.contracts.menuWednesday.Article)) {
          index = st.contracts.menuWednesday.Article.indexOf(obj.article);
          st.contracts.menuWednesday.Article.splice(index, 1);
        } else {
          st.contracts.menuWednesday.Article = [];
        }
        break;
      case 'Thursday':
        if (Array.isArray(st.contracts.menuThursday.Article)) {
          index = st.contracts.menuThursday.Article.indexOf(obj.article);
          st.contracts.menuThursday.Article.splice(index, 1);
        } else {
          st.contracts.menuThursday.Article = [];
        }
        break;
      case 'Friday':
        if (Array.isArray(st.contracts.menuFriday.Article)) {
          index = st.contracts.menuFriday.Article.indexOf(obj.article);
          st.contracts.menuFriday.Article.splice(index, 1);
        } else {
          st.contracts.menuFriday.Article = [];
        }
        break;
      default:
    }
  },
  [TYPES.MENU_ADD_TO_CART](st, obj) {
    st.cart.push([obj]);
  },
  [TYPES.CONTRACTS_TOGGLE_LINE](st, obj) {
    // const lineIndex = st.markedItems.findIndex(line => obj.lineNo === line.lineNo)
    // if (lineIndex >= 0) {
    //   st.markedItems.splice(lineIndex, 1)
    // } else {
    //   st.markedItems.push(obj)
    // }
  },
};

// Remember actions are async...
const actions = {
  toggleMarkedArticles({ commit }, obj) {
    // FIXME: No need for this in state
    // commit(TYPES.CONTRACTS_TOGGLE_LINE, obj)
  },
  setContracts({ commit }, obj) {
    commit(TYPES.CONTRACTS_SET, obj);
  },
  setActiveContract({ commit }, id) {
    commit(TYPES.CONTRACT_ACTIVE, id);
  },
  articleChangeQuantity({ commit }, item) {
    const art = findArticleLineNo(item.day, item.article.LineNo);
    const quantity = parseInt(item.qty, 10);

    if (quantity < 0) {
      commit(TYPES.SET_ARTICLE_QUANTITY, {
        article: art,
        qty: 0,
      });
    } else {
      commit(TYPES.SET_ARTICLE_QUANTITY, {
        article: art,
        qty: quantity,
      });
    }
  },
  articleChangeInterval({ commit }, obj) {
    const art = findArticleLineNo(obj.day, obj.lineno);
    commit(TYPES.SET_ARTICLE_INTERVAL, {
      art,
      interval: obj.interval,
      date: obj.date,
    });
  },
  deleteFromMenu({ commit }, obj) {
    commit(TYPES.MENU_REMOVE_ARTICLE, obj);
  },
  addToCart({ commit }, obj) {
    commit(TYPES.MENU_ADD_TO_CART, obj);
  },
};

const getters = {
  getContractNo: (state) => {
    if (state.contracts.contract) {
      return state.contracts.contract.ContractNo;
    }
    return 0;
  },
  getMonday: state => state.contracts.menuMonday,
  getTuesday: state => state.contracts.menuTuesday,
  getWednesday: state => state.contracts.menuWednesday,
  getThursday: state => state.contracts.menuThursday,
  getFriday: state => state.contracts.menuFriday,
  getContract: state => state.contracts.contract,
  isCateringCustomer: state => Boolean(state.contracts.contract.CateringCustomer),
};

const module = {
  state,
  getters,
  mutations,
  actions,
};
export default { module };



// WEBPACK FOOTER //
// ./src/app/contracts/vuex.js